module.exports = __webpack_public_path__ + "static/og_image-59c891b13b9704514dea90b099d44421.png";